import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-user-permissions',
  templateUrl: './user-permissions.component.html',
  styleUrl: './user-permissions.component.scss'
})
export class UserPermissionsComponent {

  activeTab: string = '';

  menus: any[] = [];
  loading: boolean = false;

  accMenus: any[] = [];
  advtMenus: any[] = [];
  subMenus: any[] = [];
  bookMenus: any[] = [];
  issueSellerMenus: any[] = [];

  userId: any = this.user.id;
  userName: any = this.user.name;

  constructor(
    public service: DigisubservicesService,
    public dialogRef: MatDialogRef<UserPermissionsComponent>,
    @Inject(MAT_DIALOG_DATA) public user: any
  ) { }

  ngOnInit() {
    this.loadPermissions();
  }

  loadPermissions() {
    debugger
    this.loading = true;
    // Call your PHP API to get permissions for the user
    this.service.getUserPermissions(this.userId)
      .subscribe({
        next: (res) => {
          this.menus = res.permissions.map(p => ({
            id: p.menu_id,
            name: p.menu_name,
            view: p.can_view,
            add: p.can_add,
            edit: p.can_edit,
            delete: p.can_delete,
            category: p.category
          }));

          // Filter menus based on category
          this.accMenus = this.menus.filter(menu => menu.category === 'Account');
          this.advtMenus = this.menus.filter(menu => menu.category === 'Advertisement');
          this.subMenus = this.menus.filter(menu => menu.category === 'Subscription');
          this.bookMenus = this.menus.filter(menu => menu.category === 'Book');
          this.issueSellerMenus = this.menus.filter(menu => menu.category === 'Issue Seller');

          if (this.accMenus.length > 0) {
            this.activeTab = 'acc';
          } else if (this.advtMenus.length > 0) {
            this.activeTab = 'advt';
          } else if (this.subMenus.length > 0) {
            this.activeTab = 'sub';
          } else if (this.bookMenus.length > 0) {
            this.activeTab = 'bs';
          } else if (this.issueSellerMenus.length > 0) {
            this.activeTab = 'is';
          }

          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to load permissions', err);
          this.menus = [];
          this.loading = false;
        }
      });
  }

  save() {
    const payload = {
      userId: this.userId,
      permissions: this.menus.map(menu => ({
        menu_id: menu.id,
        can_view: menu.view ? 1 : 0,
        can_add: menu.add ? 1 : 0,
        can_edit: menu.edit ? 1 : 0,
        can_delete: menu.delete ? 1 : 0
      }))
    };

    this.service.updateUserPermissions(payload)
      .subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            alert('Permissions updated successfully!');
            this.dialogRef.close(payload.permissions);
          } else {
            alert('Failed to update permissions.');
          }
        },
        error: (err) => {
          console.error('Error updating permissions', err);
          alert('Error updating permissions.');
        }
      });
  }

  selectTab(tab: string) {
    this.activeTab = tab;
  }

}